import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";
import { AVATAR_PART } from "../../assistantAvatarMotion";

// A rising thought trail at the upper right, growing away from the head.
const DOTS = [
	{ cx: 100, cy: 24, r: 3.6 },
	{ cx: 110, cy: 13, r: 4.6 },
	{ cx: 122, cy: 0, r: 5.6 },
] as const;

export const AvatarThinkingDots: FC = () => (
	<g>
		{DOTS.map(({ cx, cy, r }) => (
			<circle key={cx} className={AVATAR_PART.THINKING_DOT} cx={cx} cy={cy} r={r} fill={ASSISTANT_AVATAR.EXTRAS.THINKING_DOT} />
		))}
	</g>
);
